import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Button, Flex, Text } from 'pcln-design-system'
import { ChevronDown } from 'pcln-icons'
import { Menu, MenuItem } from 'pcln-menu'

const CenteredText = styled(Text)`
  align-items: center;
  display: flex;
  white-space: nowrap;
`

const DropdownItem = styled(MenuItem)`
  text-align: left;
`

const MenuItems = ({ color, listItems, target }) =>
  listItems.map((link) => {
    return (
      <DropdownItem
        label={link.label}
        key={`dropdown-item-${link.label}`}
        color={color}
        selected={false}
        onClick={() => window.open(link.href, target === '_blank' ? target : '_self')}
      >
        <Flex flexDirection='column' alignItems='flex-start'>
          <Text>{link.label}</Text>
        </Flex>
      </DropdownItem>
    )
  })

function Dropdown({ color, dropdownColor, dropdownWidth, fontWeight, link, target }) {
  return (
    <Flex alignItems='center'>
      <Menu
        id={`${link.label}-menu`}
        ariaLabel={`Click to open link options for ${link.label}`}
        buttonNode={
          <Button color={color} variation='link'>
            <CenteredText fontWeight={fontWeight}>
              {link.label} <ChevronDown />
            </CenteredText>
          </Button>
        }
        trapFocus={false}
        width={dropdownWidth}
      >
        <MenuItems color={dropdownColor} listItems={link.links} target={target} />
      </Menu>
    </Flex>
  )
}

Dropdown.defaultProps = {
  dropdownWidth: 250,
}

Dropdown.propTypes = {
  color: PropTypes.string,
  dropdownColor: PropTypes.string,
  dropdownWidth: PropTypes.string,
  fontWeight: PropTypes.string,
  link: PropTypes.object,
  target: PropTypes.string,
}

export default memo(Dropdown)
